import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Input, Row, Select, Space, Checkbox, Typography } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Datepicker } from "@ijavad805/react-datepicker";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import ModalMachine from "../../components/Modal/Machine/ModalMachine";
import ModalProject from "../../components/Modal/Project/ProjectModal";
import ModalLocations from "../../components/Modal/Locations/LocationModal";
import ModalMachineType from "../../components/Modal/MachineType/MachineType";
import ModalPerson from "../../components/Modal/Person/PersonModal";
import ModalEquipment from "../../components/Modal/Equipment/EquipmentModal";
import ModalOperator from "../../components/Modal/Operator/OperatorModal";
import ModalJens from "../../components/Modal/Jens/JensModal";
import ModalOrigin from "../../components/Modal/Origin/OriginModal";
import ModalDestination from "../../components/Modal/Destination/DestinationModal";
import ModalJensCodes from "../../components/Modal/JensCodes/JensCodesModal";
import ModalDefect from "../../components/Modal/Defects/DefectModal";
import ModalDelays from "../../components/Modal/Delays/DelaysModal";
import ModalShift from "../../components/Modal/Shift/ShiftModal";

const { Title } = Typography;

export default function ReportTotalBody() {
  const [form] = Form.useForm();
  const [machineData, setMachineData] = useState("");
  const [projectData, setProjectData] = useState("");
  const [locationData, setLocationData] = useState("");
  const [machineTypeData, setMachineTypeData] = useState("");
  const [personData, setPersonData] = useState("");
  const [equipmentData, setEquipmentData] = useState("");
  const [operatorData, setOperatorData] = useState("");
  const [jensData, setJensData] = useState("");
  const [originData, setOriginData] = useState("");
  const [shiftData, setShiftData] = useState("");
  const [defectData, setDefectData] = useState("");
  const [delaysData, setDelaysData] = useState("");
  const [destinationData, setDestinationData] = useState("");
  const [jensCodeData, setJensCodeData] = useState("");
  const [cargoCode, setCargoCode] = useState("");
  const [jensCodeNumber, setJensCodeNumber] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [checkboxState, setCheckboxState] = useState({
    project: false,
    location: false,
    machineType: false,
    machine: false,
    person: false,
    equipment: false,
    operator: false,
    jens: false,
    jensCode: false,
    shift: false,
    defects: false,
    delays: false,
    origin: false,
    destination: false,
  });
  const navigate = useNavigate();

  const [showModalMachine, setShowModalMachine] = useState(false);
  const [showModalProject, setShowModalProject] = useState(false);
  const [showModalLocations, setShowModalLocations] = useState(false);
  const [showModalMachineType, setShowModalMachineType] = useState(false);
  const [showModalPerson, setShowModalPerson] = useState(false);
  const [showModalEquipment, setShowModalEquipment] = useState(false);
  const [showModalOperator, setShowModalOperator] = useState(false);
  const [showModalJens, setShowModalJens] = useState(false);
  const [showModalOrigin, setShowModalOrigin] = useState(false);
  const [showModalDestination, setShowModalDestination] = useState(false);
  const [showModalJensCode, setShowModalJensCode] = useState(false);
  const [showModalShift, setShowModalShift] = useState(false);
  const [showModalDelays, setShowModalDelays] = useState(false);
  const [showModalDefect, setShowModalDefect] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);
  const [selectedLocationIds, setSelectedLocationIds] = useState([]);
  const [selectedMachineTypeIds, setSelectedMachineTypeIds] = useState([]);
  const [selectedPersonIds, setSelectedPersonIds] = useState([]);
  const [selectedEquipmentIds, setSelectedEquipmentIds] = useState([]);
  const [selectedOperatorIds, setSelectedOperatorIds] = useState([]);
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);
  const [selectedDefectIds, setSelectedDefectIds] = useState([]);
  const [selectedDelaysIds, setSelectedDelaysIds] = useState([]);
  const [selectedJensIds, setSelectedJensIds] = useState([]);
  const [selectedOriginIds, setSelectedOriginIds] = useState([]);
  const [selectedDestinationIds, setSelectedDestinationIds] = useState([]);
  const [selectedJensCodeIds, setSelectedJensCodeIds] = useState([]);

  const [operationTypes, setOperationTypes] = useState([]);

  const handleCheckboxChanges = (e) => {
    const { name, checked } = e.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const getSelectedTypeIds = () => {
    const typesMap = {
      "بارگیری": 1,
      "تخلیه بار": 2,
    };
    return operationTypes.map((type) => typesMap[type]);
  };

  const handleSubmitClick = () => {
    const selectedTypeIds = getSelectedTypeIds();
    const payload = {
      type: selectedTypeIds,
      selectedProjectIds: checkboxState.project ? selectedProjectIds : [],
      selectedLocationIds: checkboxState.location ? selectedLocationIds : [],
      selectedMachineTypeIds: checkboxState.machineType ? selectedMachineTypeIds : [],
      selectedIds: checkboxState.machine ? selectedIds : [],
      selectedPersonIds: checkboxState.person ? selectedPersonIds : [],
      selectedEquipmentIds: checkboxState.equipment ? selectedEquipmentIds : [],
      selectedOperatorIds: checkboxState.operator ? selectedOperatorIds : [],
      selectedJensIds: checkboxState.jens ? selectedJensIds : [],
      selectedOriginIds: checkboxState.origin ? selectedOriginIds : [],
      selectedDestinationIds: checkboxState.destination ? selectedDestinationIds : [],
      selectedJensCodeIds: checkboxState.jensCode ? selectedJensCodeIds : [],
      selectedShiftIds: checkboxState.shift ? selectedShiftIds : [],
      selectedDefectIds: checkboxState.defects ? selectedDefectIds : [],
      selectedDelaysIds: checkboxState.delays ? selectedDelaysIds : [],
      startDate: dateFrom || null,
      endDate: dateTo || null,
      cargoCode: cargoCode || null,
      jensCode: jensCodeNumber || null,
    };
    localStorage.setItem("reportPayload", JSON.stringify(payload));
    navigate("/reports-total/lists");
  };

  return (
    <DashboardLayout>
      <div className="p-4 bg-gray-50 min-h-screen">
        <Form form={form} layout="vertical" onFinish={handleSubmitClick}>
          <Card 
            title={
              <div className="flex items-center gap-2">
                <FilterOutlined style={{ color: "#fff" }} />
                <Title level={4} className="mb-0" style={{ color: "#fff", margin: 0 }}>فیلتر گزارش تجمیعی</Title>
              </div>
            }
            className="shadow-lg mb-6"
            headStyle={{ background: "linear-gradient(180deg, #001529 0%, #002140 100%)", border: "none", color: "#fff" }}
            bodyStyle={{ padding: "24px" }}
          >
            {/* Operation Type Section */}
            <Card 
              title="نوع عملیات" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Select
                mode="multiple"
                placeholder="انتخاب نوع عملیات"
                value={operationTypes}
                onChange={setOperationTypes}
                style={{ width: "100%" }}
                size="large"
                options={[
                  { label: "بارگیری", value: "بارگیری" },
                  { label: "تخلیه بار", value: "تخلیه بار" },
                ]}
              />
            </Card>

            {/* Filters Section */}
            <Card 
              title="فیلترها" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                {[
                  { label: "پروژه", name: "project", modalSetter: setShowModalProject, dataSetter: setProjectData, selectedIdsSetter: setSelectedProjectIds, modalState: showModalProject, modalComponent: ModalProject },
                  { label: "محل استقرار", name: "location", modalSetter: setShowModalLocations, dataSetter: setLocationData, selectedIdsSetter: setSelectedLocationIds, modalState: showModalLocations, modalComponent: ModalLocations },
                  { label: "نوع دستگاه", name: "machineType", modalSetter: setShowModalMachineType, dataSetter: setMachineTypeData, selectedIdsSetter: setSelectedMachineTypeIds, modalState: showModalMachineType, modalComponent: ModalMachineType },
                  { label: "دستگاه", name: "machine", modalSetter: setShowModalMachine, dataSetter: setMachineData, selectedIdsSetter: setSelectedIds, modalState: showModalMachine, modalComponent: ModalMachine },
                  { label: "راننده", name: "person", modalSetter: setShowModalPerson, dataSetter: setPersonData, selectedIdsSetter: setSelectedPersonIds, modalState: showModalPerson, modalComponent: ModalPerson },
                  { label: "تجهیز بارگیری", name: "equipment", modalSetter: setShowModalEquipment, dataSetter: setEquipmentData, selectedIdsSetter: setSelectedEquipmentIds, modalState: showModalEquipment, modalComponent: ModalEquipment },
                  { label: "اپراتور", name: "operator", modalSetter: setShowModalOperator, dataSetter: setOperatorData, selectedIdsSetter: setSelectedOperatorIds, modalState: showModalOperator, modalComponent: ModalOperator },
                  { label: "کالا", name: "jens", modalSetter: setShowModalJens, dataSetter: setJensData, selectedIdsSetter: setSelectedJensIds, modalState: showModalJens, modalComponent: ModalJens },
                  { label: "کد کالا", name: "jensCode", modalSetter: setShowModalJensCode, dataSetter: setJensCodeData, selectedIdsSetter: setSelectedJensCodeIds, modalState: showModalJensCode, modalComponent: ModalJensCodes },
                  { label: "شیفت", name: "shift", modalSetter: setShowModalShift, dataSetter: setShiftData, selectedIdsSetter: setSelectedShiftIds, modalState: showModalShift, modalComponent: ModalShift },
                  { label: "نقص فنی", name: "defects", modalSetter: setShowModalDefect, dataSetter: setDefectData, selectedIdsSetter: setSelectedDefectIds, modalState: showModalDefect, modalComponent: ModalDefect },
                  { label: "تاخیر", name: "delays", modalSetter: setShowModalDelays, dataSetter: setDelaysData, selectedIdsSetter: setSelectedDelaysIds, modalState: showModalDelays, modalComponent: ModalDelays },
                  { label: "مبدا", name: "origin", modalSetter: setShowModalOrigin, dataSetter: setOriginData, selectedIdsSetter: setSelectedOriginIds, modalState: showModalOrigin, modalComponent: ModalOrigin },
                  { label: "مقصد", name: "destination", modalSetter: setShowModalDestination, dataSetter: setDestinationData, selectedIdsSetter: setSelectedDestinationIds, modalState: showModalDestination, modalComponent: ModalDestination },
                ].map((item, index) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={item.name}>
                    <Space direction="vertical" className="w-full">
                      <Checkbox
                        name={item.name}
                        checked={checkboxState[item.name]}
                        onChange={handleCheckboxChanges}
                        className="font-medium"
                      >
                        {item.label}
                      </Checkbox>
                      <Input
                        readOnly
                        onClick={(e) => {
                          e.stopPropagation();
                          item.modalSetter(true);
                        }}
                        placeholder={`انتخاب ${item.label}`}
                        value={
                          item.name === "machine" ? machineData :
                          item.name === "project" ? projectData :
                          item.name === "location" ? locationData :
                          item.name === "machineType" ? machineTypeData :
                          item.name === "person" ? personData :
                          item.name === "equipment" ? equipmentData :
                          item.name === "operator" ? operatorData :
                          item.name === "jens" ? jensData :
                          item.name === "jensCode" ? jensCodeData :
                          item.name === "shift" ? shiftData :
                          item.name === "defects" ? defectData :
                          item.name === "delays" ? delaysData :
                          item.name === "origin" ? originData :
                          item.name === "destination" ? destinationData : ""
                        }
                        addonAfter={
                          <SearchOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              item.modalSetter(true);
                            }} 
                            className="cursor-pointer text-blue-600 hover:text-blue-800"
                          />
                        }
                        className="cursor-pointer"
                      />
                    </Space>
                  </Col>
                ))}
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="شماره حواله">
                    <Input
                      value={cargoCode}
                      onChange={(e) => setCargoCode(e.target.value)}
                      placeholder="شماره حواله"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="رهگیری کد کالا">
                    <Input
                      value={jensCodeNumber}
                      onChange={(e) => setJensCodeNumber(e.target.value)}
                      placeholder="رهگیری کد کالا"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Date Range Section */}
            <Card 
              title="بازه تاریخی" 
              size="small" 
              className="mb-6 shadow-md"
              headStyle={{ background: "#f5f5f5", borderBottom: "1px solid #e8e8e8" }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item label="از تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="از تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateFrom(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="تا تاریخ">
                    <Datepicker
                      input={
                        <input
                          type="date"
                          placeholder="تا تاریخ"
                          className="form-control text-sm flex-1 border-2 rounded-xl p-3 pr-12 w-full"
                        />
                      }
                      adjustPosition={"modal"}
                      onChange={(val) => {
                        setDateTo(val.format());
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {/* Submit Button */}
            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                size="large"
                className="w-full h-12 text-lg font-semibold shadow-md hover:shadow-lg transition-all"
                style={{
                  background: "linear-gradient(180deg, #001529 0%, #002140 100%)",
                  border: "none",
                }}
              >
                نمایش گزارش
              </Button>
            </Form.Item>
          </Card>
        </Form>

        {/* Modals for selecting data */}
        <ModalMachine 
          showModal={showModalMachine} 
          setShowModal={setShowModalMachine} 
          setData={machineData || ""} 
          onSelectedIdsChange={(data) => {
            if (data && typeof data === "object" && data.title) {
              setMachineData(data.title);
              setSelectedIds([data.id]);
            } else if (Array.isArray(data)) {
              setSelectedIds(data);
            }
          }} 
        />
        <ModalProject 
          showModal={showModalProject} 
          setShowModal={setShowModalProject} 
          setData={projectData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedProjectIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalLocations 
          showModal={showModalLocations} 
          setShowModal={setShowModalLocations} 
          setData={locationData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedLocationIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalMachineType 
          showModal={showModalMachineType} 
          setShowModal={setShowModalMachineType} 
          setData={machineTypeData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedMachineTypeIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalPerson 
          showModal={showModalPerson} 
          setShowModal={setShowModalPerson} 
          setData={personData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedPersonIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalEquipment 
          showModal={showModalEquipment} 
          setShowModal={setShowModalEquipment} 
          setData={equipmentData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedEquipmentIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalOperator 
          showModal={showModalOperator} 
          setShowModal={setShowModalOperator} 
          setData={operatorData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedOperatorIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalJens 
          showModal={showModalJens} 
          setShowModal={setShowModalJens} 
          setData={jensData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedJensIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalOrigin 
          showModal={showModalOrigin} 
          setShowModal={setShowModalOrigin} 
          setData={originData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedOriginIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalDestination 
          showModal={showModalDestination} 
          setShowModal={setShowModalDestination} 
          setData={destinationData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedDestinationIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalJensCodes 
          showModal={showModalJensCode} 
          setShowModal={setShowModalJensCode} 
          setData={jensCodeData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedJensCodeIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalDefect 
          showModal={showModalDefect} 
          setShowModal={setShowModalDefect} 
          setData={defectData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedDefectIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalDelays 
          showModal={showModalDelays} 
          setShowModal={setShowModalDelays} 
          setData={delaysData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedDelaysIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
        <ModalShift 
          showModal={showModalShift} 
          setShowModal={setShowModalShift} 
          setData={shiftData || ""} 
          onSelectedIdsChange={(ids) => {
            setSelectedShiftIds(Array.isArray(ids) ? ids : [ids]);
          }} 
        />
      </div>
    </DashboardLayout>
  );
}
